import * as React from "react";
import { default as Task, ITaskProps } from "../bits/task";
import { default as DatabaseData, IMigrations } from "../data/database";


interface IDatabaseProps {
    data: DatabaseData
    tasks: { [id: string]: ITaskProps }
    handleError: (e: any) => void
}

interface IState {
    migrations: IMigrations
}

export default class Database extends React.Component<IDatabaseProps, IState> {
    public state: IState = {
        migrations: { applied: [], pending: [] }
    };
    private isActive = true;

    constructor(props: IDatabaseProps) {
        super(props);
        this.props.data.migrations()
            .then(d => d && this.isActive && this.setState({ migrations: d }))
            .catch(this.props.handleError);
    }

    public componentWillUnmount() {
        this.isActive = false;
    }

    public render() {
        return <div className="content">
            <h1>Database</h1>
            <div className="commands">
                {/* tslint:disable-next-line:jsx-no-lambda */}
                <button className="button" onClick={e => {
                    const btn = e.currentTarget;
                    e.preventDefault();
                    btn.disabled = true;
                    this.props.data.migrate().then(
                        () => btn.disabled = false,
                        () => btn.disabled = false
                    );
                }}>
                    <i className="fa fa-upload" /> Migrer database
                </button>
                {/* tslint:disable-next-line:jsx-no-lambda */}
                <button className="button" onClick={e => {
                    const btn = e.currentTarget;
                    e.preventDefault();
                    btn.disabled = true;
                    this.props.data.reinit().then(
                        () => btn.disabled = false,
                        () => btn.disabled = false
                    );
                }}>
                    <i className="fa fa-upload" /> Gjenopprett NOBB-database
                </button>
            </div>
            {
                Object.keys(this.props.tasks)
                    .map(id => <Task {...this.props.tasks[id]} key={id} />)
            }
            <h2>Applied migrations</h2>
            <div className="list">
                {this.state.migrations.applied.map(x => <div key={x}>{x}</div>)}
            </div>
            <h2>Pending migrations</h2>
            <div className="list">
                {this.state.migrations.pending.map(x => <div key={x}>{x}</div>)}
            </div>
        </div>;
    }
}


// WEBPACK FOOTER //
// ./src/database/database.tsx